import { useEffect } from 'react';
import { View } from 'react-native';

import { COLORS, Select, Text, HRule } from '../Basics';
import { useStore } from '../../store/Context';
import { THEME_OPTIONS } from '../../theme/lorentzThemes';

export const ThemeSettings = () => {
  const { theme = 'auto', setTheme } = useStore();

  return (
    <View>
      <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 8, color: COLORS.textPrimary }}>
        Tema
      </Text>
      <Select
        options={THEME_OPTIONS.map(o => ({ value: o.value, text: o.label }))}
        value={theme}
        onChange={val => setTheme?.(val)}
      />
      <Text
        style={{
          fontSize: 11,
          color: COLORS.textSecondary,
          marginTop: 6
        }}
      >
        Automático segue o tema do navegador (Lorentz Dark / Lorentz Light).
      </Text>
      <HRule />
    </View>
  );
};

export default ThemeSettings;
